import React, { useState } from "react";
import useLogout from "../../hooks/useLogout";
import { useNavigate } from "react-router-dom";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ArcElement
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import "chartjs-plugin-datalabels";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    ArcElement,
    ChartDataLabels,
    Title,
    Tooltip,
    Legend
);

export const options = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top',
        },
        datalabels: {
            display: true,
            color: "black",
            align: "end",
            padding: {
                right: 2
            },
            labels: {
                padding: { top: 10 },
                title: {
                    font: {
                        weight: "bold"
                    }
                },
                value: {
                    color: "green"
                }
            },
            formatter: function (value) {
                return "\n" + value;
            }
        }
    },
};

const labels = ['Q1', 'Q2', 'Q3', 'Q4', 'Q1', 'Q2', 'Q3', 'Q4', 'Q1', 'Q2', 'Q3', 'Q4'];

export const data1 = {
    labels,
    datasets: [
        {
            label: 'ข้าวโพด',
            data: [8.6, 9.2, 9.5, 8.8, 9.4, 9.5, 10.6, 10.8, 11.5, 12.5, 12.8, 12.1],
            borderColor: 'rgb(255, 99, 132)',
            backgroundColor: 'rgba(255, 99, 132, 0.5)',
        },
    ],
};

export const data2 = {
    labels,
    datasets: [
        {
            label: 'ข้าวสาลี',
            data: [8.6, 8.9, 8.7, 8.5, 9.7, 10.0, 10.6, 12.6, 12.7, 14.6, 14.8, 15.1],
            borderColor: 'rgb(53, 162, 235)',
            backgroundColor: 'rgba(53, 162, 235, 0.5)',
        },
    ],
};

export const data3 = {
    labels,
    datasets: [
        {
            label: 'กากถั่วเหลือง',
            data: [13.8, 14.4, 14.4, 17.2, 19.3, 19.3, 19.1, 18.9, 18.2, 20.7, 20.6, 21.1],
            borderColor: 'rgba(255, 159, 64)',
            backgroundColor: 'rgba(255, 159, 64, 0.5)',
        },
    ],
};

export const data = {
    labels,
    datasets: [
        {
            label: 'ข้าวโพด',
            data: [8.6, 9.2, 9.5, 8.8, 9.4, 9.5, 10.6, 10.8, 11.5, 12.5, 12.8, 12.1],
            borderColor: 'rgb(255, 99, 132)',
            backgroundColor: 'rgba(255, 99, 132, 0.5)',
        },
        {
            label: 'ข้าวสาลี',
            data: [8.6, 8.9, 8.7, 8.5, 9.7, 10.0, 10.6, 12.6, 12.7, 14.6, 14.8, 15.1],
            borderColor: 'rgb(53, 162, 235)',
            backgroundColor: 'rgba(53, 162, 235, 0.5)',
        },
        {
            label: 'กากถั่วเหลือง',
            data: [13.8, 14.4, 14.4, 17.2, 19.3, 19.3, 19.1, 18.9, 18.2, 20.7, 20.6, 21.1],
            borderColor: 'rgba(255, 159, 64)',
            backgroundColor: 'rgba(255, 159, 64, 0.5)',
        },
    ],
};

export const pieData = {
    labels: ['CP Group', 'New Hope Group', 'Cargill', "Land O'Lake", "Wen's Food Group", 'Others'],
    datasets: [
        {
            data: [33, 26, 20, 14, 13, 1131],
            backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
            ],
            borderColor: [
                'rgba(255, 99, 132, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
            ],
            borderWidth: 1,
        },
    ],
};

export default function InsightForm() {
    const navigate = useNavigate();
    const logout = useLogout();

    const signOut = async () => {
        await logout();
        navigate('/login');
    }

    return (
        <div className="insight">
            <header className="insight-header">
                <img className="cpf-logo" src="/assets/cpf-logo.jpg" />
                <div className="navbar">
                    <a className="navbar-item" href="/AI">
                        <div className="top-nav-item">AI</div>
                    </a>
                    <a className="navbar-item" href="/insight">
                        <div className="top-nav-item">Insight</div>
                    </a>
                    <a className="navbar-item" href="/power-bi">
                        <div className="top-nav-item">power BI</div>
                    </a>
                </div>
                <button className="sign-out-button" onClick={signOut}>Sign Out</button>
            </header>
            <body className="insight-body">
                <div className="insight-grid-header">
                    <div className="insight-item">
                        <div className="insight-title">โรงงานผลิตอาหารสัตว์ซีพีเอฟ ทั่วโลก ปี 2021</div>
                        <table className="insight-table">
                            <tr>
                                <th>ประเทศ</th>
                                <th>กำลังการผลิต</th>
                                <th>ผลิตจริง</th>
                                <th>%ใช้งาน</th>
                                <th id="th-color">%ใช้เอง</th>
                                <th id="th-color">%ขายลูกค้า</th>
                            </tr>
                            <tr>
                                <td>จีน</td>
                                <td>16.6</td>
                                <td>11.4</td>
                                <td>69%</td>
                                <td>42%</td>
                                <td>58%</td>
                            </tr>
                            <tr>
                                <td>ไทย</td>
                                <td>7.1</td>
                                <td>6.0</td>
                                <td>84%</td>
                                <td>66%</td>
                                <td>34%</td>
                            </tr>
                            <tr>
                                <td>เวียดนาม</td>
                                <td>4.7</td>
                                <td>3.9</td>
                                <td>83%</td>
                                <td>68%</td>
                                <td>32%</td>
                            </tr>
                            <tr>
                                <td>อินโดนีเซีย</td>
                                <td>7.5</td>
                                <td>5.6</td>
                                <td>75%</td>
                                <td>59%</td>
                                <td>41%</td>
                            </tr>
                            <tr>
                                <td>อื่นๆ (11ประเทศ)</td>
                                <td>7.8</td>
                                <td>5.9</td>
                                <td>81%</td>
                                <td>51%</td>
                                <td>49%</td>
                            </tr>
                            <tr id="tr-color">
                                <td>รวม</td>
                                <td>43.7</td>
                                <td>32.7</td>
                                <td>75%</td>
                                <td id="th-color">55%</td>
                                <td id="th-color">45%</td>
                            </tr>
                        </table>
                        <div className="insight-title">อุตสาหกรรมอาหารสัตว์ประเทศไทย ปี 2022</div>
                        <div className="insight-table-grid">
                            <div className="insight-table-flex">
                                <div className="insight-table-title">ตลาดรวมอาหารสัตว์</div>
                                <div className="insight-table-subtitle-flex">
                                    <div className="insight-table-number">16</div>
                                    <div className="insight-table-subtitle">ล้านตัน/ปี</div>
                                </div>
                            </div>
                            <div className="insight-table-flex">
                                <div className="insight-table-title">มูลค่าตลาดรวม</div>
                                <div className="insight-table-subtitle-flex">
                                    <div className="insight-table-number">220,000</div>
                                    <div className="insight-table-subtitle">ล้านบาท/ปี</div>
                                </div>
                            </div>
                        </div>
                        <div className="insight-table-bottom-grid">
                            <div className="insight-table-flex">
                                <div className="insight-table-title">ปริมาณการผลิตซีพีเอฟ</div>
                                <div className="insight-table-subtitle-flex">
                                    <div className="insight-table-number">6.4</div>
                                    <div className="insight-table-subtitle">ล้านตัน/ปี</div>
                                </div>
                            </div>
                            <div className="insight-table-flex">
                                <div className="insight-table-title">มูลค่าอาหารสัตว์ซีพีเอฟ</div>
                                <div className="insight-table-subtitle-flex">
                                    <div className="insight-table-number">90,000</div>
                                    <div className="insight-table-subtitle">ล้านบาท/ปี</div>
                                </div>
                            </div>
                            <div className="insight-table-flex">
                                <div className="insight-table-title">ส่วนแบ่งการตลาด</div>
                                <div className="insight-table-number">40%</div>
                            </div>
                        </div>
                    </div>
                    <div className="insight-item">
                        <div className="insight-title">ผู้นำการผลิตอาหารสัตว์ของโลก ปี 2021</div>
                        <table className="insight-table">
                            <tr>
                                <th>No.</th>
                                <th>Name</th>
                                <th>Country</th>
                                <th>Volume (Million Tons/Yr.)</th>
                                <th>Share (%)</th>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>CP Group</td>
                                <td>Thailand</td>
                                <td>33</td>
                                <td>3%</td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>New Hope Group</td>
                                <td>China</td>
                                <td>26</td>
                                <td>2%</td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Cargill</td>
                                <td>USA</td>
                                <td>20</td>
                                <td>2%</td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>Land O’Lake</td>
                                <td>USA</td>
                                <td>14</td>
                                <td>1%</td>
                            </tr>
                            <tr>
                                <td>5</td>
                                <td>Wen’s Food Group</td>
                                <td>China</td>
                                <td>13</td>
                                <td>1%</td>
                            </tr>
                            <tr>
                                <td>6</td>
                                <td>Others</td>
                                <td></td>
                                <td>1,131</td>
                                <td>91%</td>
                            </tr>
                            <tr id="tr-color">
                                <td style={{ border: '0' }}></td>
                                <td style={{ border: '0' }}>Total</td>
                                <td style={{ border: '0' }}></td>
                                <td style={{ border: '0' }}>1,236</td>
                                <td style={{ border: '0' }}>100% </td>
                            </tr>
                        </table>
                        <div className="insight-title">โรงงานผลิตอาหารสัตว์ซีพีเอฟ ทั่วโลก ปี 2021</div>
                        <div className="production-leader-title">ขยายธุรกิจใน <span className="production-number">15</span> ประเทศกำลังการผลิต <span className="production-number">43</span> ล้านตัน</div>
                        <div className="production-leader-title">ผลิตจริง <span className="production-number">33</span> ล้านตัน % ใช้งาน 75%</div>
                        <ul>
                            <li className="production-leader-subtitle">ผลิตเพื่อใช้เอง 18 ล้านตัน (55%)</li>
                            <li className="production-leader-subtitle">ผลิตเพื่อขายตลาดอิสระ 15ล้านตัน(45%)</li>
                        </ul>
                    </div>
                    <div className="insight-item">
                        <div className="insight-title">ส่วนแบ่งการตลาดอาหารสัตว์ประเทศไทย ปี 2022</div>
                        <table className="insight-table">
                            <tr>
                                <th>บริษัท</th>
                                <th>ปริมาณการผลิต (ล้านตัน/ปี ) </th>
                                <th>ส่วนแบ่งการตลาด ( % )</th>
                            </tr>
                            <tr style={{ background: '#f1f8ec', fontSize: '16px', color: '#086404', fontWeight: 'bold' }}>
                                <td>CPF</td>
                                <td>6.4</td>
                                <td>40</td>
                            </tr>
                            <tr>
                                <td>เบทาโกร</td>
                                <td>2.6</td>
                                <td>17</td>
                            </tr>
                            <tr>
                                <td>ไทยฟู้ดส์</td>
                                <td>1.1</td>
                                <td>7</td>
                            </tr>
                            <tr>
                                <td>คาร์กิลล์</td>
                                <td>0.8</td>
                                <td>5</td>
                            </tr>
                            <tr>
                                <td>อื่นๆ</td>
                                <td>5.1</td>
                                <td>31</td>
                            </tr>
                            <tr>
                                <td>รวม</td>
                                <td>16.0</td>
                                <td>100</td>
                            </tr>
                            <tr id="tr-color">
                                <td style={{ border: '0' }}></td>
                                <td style={{ border: '0' }}>Total</td>
                                <td style={{ border: '0' }}></td>
                            </tr>
                        </table>
                        <div className="insight-title">ปริมาณการผลิตอาหารสัตว์ ซีพีเอฟ ปี 2022</div>
                        <div className="feed-production-flex">
                            <div className="feed-production-grid">
                                <div className="feed-production-title">ปริมาณการผลิต</div>
                                <div className="feed-production-title">ซีพีเอฟ</div>
                                <div className="feed-production-number">6.4</div>
                                <div className="feed-production-subtitle">ล้านตัน </div>
                            </div>
                            <ul className="feed-production-center">
                                <li className="production-leader-subtitle">ผลิตเพื่อใช้เอง <span className="production-number">4.2</span> ล้านตัน (66%)</li>
                                <li className="production-leader-subtitle">ขายลูกค้า <span className="production-number">2.2</span> ล้านตัน (34%)</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="insight-grid">
                    <div className="insight-item">
                        <div className="insight-title">สถานการณ์ข้าวโพด</div>
                        <div className="insight-unit">หน่วย : บาท/กก.</div>
                        <Line options={options} data={data1} />
                        <div className="insight-quarter">
                            <div>2020</div>
                            <div>2021</div>
                            <div>2022</div>
                        </div>
                    </div>
                    <div className="insight-item">
                        <div className="insight-title">สถานการณ์ข้าวสาลี</div>
                        <div className="insight-unit">หน่วย : บาท/กก.</div>
                        <Line options={options} data={data2} />
                        <div className="insight-quarter">
                            <div>2020</div>
                            <div>2021</div>
                            <div>2022</div>
                        </div>
                    </div>
                    <div className="insight-item">
                        <div className="insight-title">สถานการณ์กากถั่วเหลือง</div>
                        <div className="insight-unit">หน่วย : บาท/กก.</div>
                        <Line options={options} data={data3} />
                        <div className="insight-quarter">
                            <div>2020</div>
                            <div>2021</div>
                            <div>2022</div>
                        </div>
                    </div>
                    <div className="insight-item">
                        <div className="insight-title">สถานการณ์วัตถุดิบหลักที่ใช้ในปี 2022</div>
                        <div className="insight-unit">หน่วย : บาท/กก.</div>
                        <Line options={options} data={data} />
                        <div className="insight-quarter">
                            <div>2020</div>
                            <div>2021</div>
                            <div>2022</div>
                        </div>
                    </div>
                </div>
            </body>
            <footer className="insight-footer"></footer>
        </div>
    );
}
